module.exports = __webpack_public_path__ + "img/icon-clear.1872eff3.svg";